import React from "react";

export default function Tokenomics() {
  return (
    <div className="tokenomics">
      <div className="container">
        <div className="row mt-6">
          <div className="col-md-5">
            <div className="row text-center">
              <div className="col-md-12 tokenomic-bg-mob text-center">
                <img
                  src="./Asserts/token-bg-mob.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div className="row">
              <div className="col-5 ">
                <h6>Buy</h6>
              </div>

              <div className="col-7 ">
                <h5>10%</h5>
                <img
                  src="./Asserts/token-item.png"
                  className="img-fluid rotation bg-img"
                  alt=""
                />
              </div>
            </div>

            <div className="row">
              <div className="col-5">
                <h6>Marketing</h6>
              </div>
              <div className="col-7">
                <h5>8%</h5>
                <img
                  src="./Asserts/token-item.png"
                  className="img-fluid rotation bg-img"
                  alt=""
                />
              </div>
            </div>

            <div className="row">
              <div className="col-5">
                <h6>LP</h6>
              </div>
              <div className="col-7">
                <h5>2%</h5>
                <img
                  src="./Asserts/token-item.png"
                  className="img-fluid rotation bg-img"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="col-md-2 tokenomic-bg-lap text-center">
            <img src="./Asserts/token-bg.png" className="img-fluid" alt="" />
          </div>
          <div className="col-md-5 mt-5 mt-md-0">
            <div className="row">
              <div className="col-7">
                <h4>15%</h4>
                <img
                  src="./Asserts/token-item.png"
                  className="img-fluid bg-img"
                  alt=""
                />
              </div>
              <div className="col-5">
                <h6>Sell</h6>
              </div>
            </div>
            <div className="row">
              <div className="col-7">
                <h4>11%</h4>
                <img
                  src="./Asserts/token-item.png"
                  className="img-fluid bg-img"
                  alt=""
                />
              </div>
              <div className="col-5">
                <h6>Marketing</h6>
              </div>
            </div>
            <div className="row">
              <div className="col-7">
                <h4>4%</h4>
                <img
                  src="./Asserts/token-item.png"
                  className="img-fluid bg-img"
                  alt=""
                />
              </div>
              <div className="col-5">
                <h6>LP</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
